var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConveyorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50mm",
    height: "50mm",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.423 22.78h6.02M11.455 25.155h3.587M11.445 27.582h3.412M33.09 5.819h4.755v7.53H33.09z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.581,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M6.964 34.094c-4.19.355-7.468 5.012-6.147 9.065.988 3.538 4.969 6.071 8.582 5.038 2.125-.499 3.99-2.152 4.87-4.035.675-1.376.821-3.193.38-4.739-.802-3.04-3.732-5.466-6.93-5.35a9.27 9.27 0 00-.755.02zm.809 2.223c3.42-.155 5.988 4.024 4.422 7.033-1.333 2.981-5.9 3.78-8.065 1.272-2.162-2.237-1.513-6.579 1.442-7.805.682-.336 1.445-.483 2.2-.5zM41.857 33.96c-3.5.118-6.59 3.142-6.775 6.64-.325 3.456 2.249 6.856 5.645 7.527 3.218.76 6.76-1.076 8.053-4.106 1.403-2.987.34-6.83-2.362-8.71a7.143 7.143 0 00-4.561-1.352zm.4 2.241c2.594-.057 4.921 2.242 4.888 4.837.118 2.594-2.138 4.977-4.736 4.988-2.625.178-5.08-2.096-5.088-4.73-.177-2.623 2.098-5.077 4.73-5.087.069 0 .137-.01.206-.008z",
    color: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M41.152 33.497l-.603.001-4.31.006h-.911l.006 3.093.679-.002a7.724 7.724 0 015.14-3.098zm-8.917.014l-5.727.012h-.46l.006 3.094h.46l5.727-.013zm-9.28.019l-6.185.013.007 3.09 6.184-.01zm-9.278.017l-1.923.002-3.587.002c.17.01.34.025.508.048 1.992.19 3.774 1.272 5.006 2.804zm21.67 12.227l.002 3.093h.911l4.31-.006h.968v-.075a7.712 7.712 0 01-5.427-3.012zm-3.093.005l-5.727.004h-.46l.002 3.093.46-.002 5.727-.004zm-9.28.006l-6.187.004.005 3.093 6.184-.004zm-9.28.263c-1.181 1.435-2.862 2.471-4.708 2.776-.146.03-.293.054-.44.073l3.23-.008 1.922-.002z",
    color: "#000"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.865,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.98 1.927H41.66v29.337H7.98z"
  })));
}
export default SvgConveyorIcon;